import { render } from "./PanelClienteResumen.vue?vue&type=template&id=1bb9ab52&scoped=true"
import script from "./PanelClienteResumen.vue?vue&type=script&lang=js"
export * from "./PanelClienteResumen.vue?vue&type=script&lang=js"

import "./PanelClienteResumen.vue?vue&type=style&index=0&id=1bb9ab52&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb9ab52"]])

export default __exports__